<template>
    <div>
        <button class="ds-btn" @click="isModalVisible = true">Pievienot</button>

        <b-modal v-model="isModalVisible" hide-footer no-close-on-backdrop body-class="p-2" header-class="bg-light align-items-center"
                 size="lg">
            <div slot="modal-title">
                <h3 class="h4 text-dark font-weight-light m-0">Jauns darba apstāklis</h3>
            </div>
            <div slot="modal-header-close">
            </div>
            <OvpJobConditionBaseForm @finished="handleOvpJobConditionCreation"/>
        </b-modal>
    </div>
</template>
<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex';

    import OvpJobConditionBaseForm from './OvpJobConditionBaseForm';
   
    import * as ovpStoreTypes from '../../vuex/modules/ovp/ovp.store-types';
    import * as companyStoreTypes from '../../vuex/modules/company/company.store-types';

    export default {
        name: 'ovp-job-conditions-add',
        components: {OvpJobConditionBaseForm},
        data: () => ({isModalVisible: false}),
        computed: {
            ...mapGetters('company', {
                /** @type {Company|*} */
                currentCompany: companyStoreTypes.GET_CURRENT_COMPANY,
            }),
        },
        methods: {
            ...mapMutations('company', {
                /** @type {function|*} */
                setCurrentCompanyOvpJobConditions: companyStoreTypes.SET_CURRENT_COMPANY_OVP_JOB_CONDITIONS,
            }),
            ...mapActions('ovp', {
                /** @type {function|*} */
                getOvpJobConditions: ovpStoreTypes.ACTION_GET_OVP_JOB_CONDITIONS,
            }),
            async handleOvpJobConditionCreation() {
                this.isModalVisible = false;

                //For template categories currentCompany._id will be empty
                const ovpJobConditions = await this.getOvpJobConditions({companyId: this.currentCompany._id});

                if (!this.currentCompany._id) {
                    return;
                }
            
                this.setCurrentCompanyOvpJobConditions(ovpJobConditions);
            },
        },
    }
</script>